import { useTranslation } from 'react-i18next';
import { Button } from 'antd';
import { useScheduleBoardContext } from 'pos-client/components/scheduleBoard/context/ScheduleBoardContext.tsx';
import ScheduleBoard from 'pos-client/components/scheduleBoard/ScheduleBoard.tsx';
import { PosModal } from 'pos-client/components/shared/Display/Modal/PosModal.tsx';

const ScheduleBoardModal = () => {
  const { t } = useTranslation();
  const { showScheduleModal, setShowScheduleModal } = useScheduleBoardContext();

  return (
    <PosModal
      open={showScheduleModal}
      onCancel={() => setShowScheduleModal(false)}
      width={'96vw'}
      styles={{
        body: {
          maxHeight: '85vh',
          overflowY: 'scroll',
        },
      }}
      footer={
        <Button type="primary" onClick={() => setShowScheduleModal(false)}>
          {t('common.buttons.close')}
        </Button>
      }
    >
      <ScheduleBoard />
    </PosModal>
  );
};

export default ScheduleBoardModal;
